

// import { useState } from 'react'
// import {
//   Dialog,
//   DialogBackdrop,
//   DialogPanel,
//   Disclosure,
//   DisclosureButton,
//   DisclosurePanel,
//   Menu,
//   MenuButton,
//   MenuItem,
//   MenuItems,
// } from '@headlessui/react'
// import { XMarkIcon } from '@heroicons/react/24/outline'
// import { ChevronDownIcon, FunnelIcon, MinusIcon, PlusIcon, Squares2X2Icon } from '@heroicons/react/20/solid'
// import Header from 'units/dashboard/components/Header'
// import UserSidebar from 'units/user/components/UserSidebar'
// import Footer from 'units/dashboard/components/Footer'


// const sortOptions = [
//   { name: 'Most Popular', href: '#', current: true },
//   { name: 'Best Rating', href: '#', current: false },
//   { name: 'Newest', href: '#', current: false },
//   { name: 'Price: Low to High', href: '#', current: false },
//   { name: 'Price: High to Low', href: '#', current: false },
// ]
// const subCategories = [
//   { name: 'Totes', href: '#' },
//   { name: 'Backpacks', href: '#' },
//   { name: 'Travel Bags', href: '#' },
//   { name: 'Hip Bags', href: '#' },
//   { name: 'Laptop Sleeves', href: '#' },
// ]
// const filters = [
//   {
//     id: 'color',
//     name: 'Color',
//     options: [
//       { value: 'white', label: 'White', checked: false },
//       { value: 'beige', label: 'Beige', checked: false },
//       { value: 'blue', label: 'Blue', checked: true },
//       { value: 'brown', label: 'Brown', checked: false },
//       { value: 'green', label: 'Green', checked: false },
//       { value: 'purple', label: 'Purple', checked: false },
//     ],
//   },
//   {
//     id: 'category',
//     name: 'Category',
//     options: [
//       { value: 'new-arrivals', label: 'New Arrivals', checked: false },
//       { value: 'sale', label: 'Sale', checked: false },
//       { value: 'travel', label: 'Travel', checked: true },
//       { value: 'organization', label: 'Organization', checked: false },
//       { value: 'accessories', label: 'Accessories', checked: false },
//     ],
//   },
//   {
//     id: 'size',
//     name: 'Size',
//     options: [
//       { value: '2l', label: '2L', checked: false },
//       { value: '6l', label: '6L', checked: false },
//       { value: '12l', label: '12L', checked: false },
//       { value: '18l', label: '18L', checked: false },
//       { value: '20l', label: '20L', checked: false },
//       { value: '40l', label: '40L', checked: true },
//     ],
//   },
// ]

// function classNames(...classes) {
//   return classes.filter(Boolean).join(' ')
// }

// export default function AddNewTool() {
//   const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false)
//   console.log("Dialog open:", mobileFiltersOpen);
//   return (
//     <>

//     <nav className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
//       <Header />
//     </nav>

//     <div className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
//       <UserSidebar />
//     </div>

//     <div className="flex flex-col min-h-screen">
//       <div className="main-content flex-grow ">
//         <div className="page-content mt-1">
//           <div className="container-fluid px-[0.625rem]">
//             <div className="grid grid-cols-1 mb-2">
//               <div className="flex items-center justify-between">
//                 {/* <h4 className="mb-sm-0 text-2xl font-semibold grow text-gray-800 ">
//                   داشبورد
//                 </h4> */}
//                 <nav className="flex" aria-label="Breadcrumb"></nav>
//               </div>
//             </div>
//             {/* <h1 className="text-lg mr-2"> مدیر محترم به داشبورد کاربری خوش آمدید . </h1> */}
//           </div>
//           <div className="bg-white">

//         {/* Mobile filter dialog */}


//         <main className="mx-auto  px-4 sm:px-6 lg:px-8 relative flex w-full">
//         {/* <Dialog open={mobileFiltersOpen} onClose={setMobileFiltersOpen} className="absolute z-[9999] lg:hidden">
//           <DialogBackdrop
//             transition
//             className="fixed inset-0 bg-black/25 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
//           />

//           <div className="fixed inset-0 z-40 flex">
//             <DialogPanel
//               transition
//               className="relative ml-auto flex size-full max-w-xs transform flex-col overflow-y-auto bg-white pb-6 pt-4 shadow-xl transition duration-300 ease-in-out data-[closed]:translate-x-full"
//             >
//               <div className="flex items-center justify-between px-4">
//                 <h2 className="text-lg font-medium text-gray-900">Filters</h2>
//                 <button
//                   type="button"
//                   onClick={() => setMobileFiltersOpen(false)}
//                   className="relative -mr-2 flex size-10 items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                 >
//                   <span className="absolute -inset-0.5" />
//                   <span className="sr-only">Close menu</span>
//                   <XMarkIcon aria-hidden="true" className="size-6" />
//                 </button>
//               </div>

//               {/* Filters */}
//               <form className="mt-4 border-t border-gray-200">
//                 <h3 className="sr-only">Categories</h3>
//                 <ul role="list" className="px-2 py-3 font-medium text-gray-900">
//                   {subCategories.map((category) => (
//                     <li key={category.name}>
//                       <a href={category.href} className="block px-2 py-3">
//                         {category.name}
//                       </a>
//                     </li>
//                   ))}
//                 </ul>

//                 {filters.map((section) => (
//                   <Disclosure key={section.id} as="div" className="border-t border-gray-200 px-4 py-6">
//                     <h3 className="-mx-2 -my-3 flow-root">
//                       <DisclosureButton className="group flex w-full items-center justify-between bg-white px-2 py-3 text-gray-400 hover:text-gray-500">
//                         <span className="font-medium text-gray-900">{section.name}</span>
//                         <span className="ml-6 flex items-center">
//                           <PlusIcon aria-hidden="true" className="size-5 group-data-[open]:hidden" />
//                           <MinusIcon aria-hidden="true" className="size-5 group-[:not([data-open])]:hidden" />
//                         </span>
//                       </DisclosureButton>
//                     </h3>
//                     <DisclosurePanel className="pt-6">
//                       <div className="space-y-6">
//                         {section.options.map((option, optionIdx) => (
//                           <div key={option.value} className="flex gap-3">
//                             <div className="flex h-5 shrink-0 items-center">
//                               <div className="group grid size-4 grid-cols-1">
//                                 <input
//                                   defaultValue={option.value}
//                                   id={`filter-mobile-${section.id}-${optionIdx}`}
//                                   name={`${section.id}[]`}
//                                   type="checkbox"
//                                   className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
//                                 />
//                                 <svg
//                                   fill="none"
//                                   viewBox="0 0 14 14"
//                                   className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
//                                 >
//                                   <path
//                                     d="M3 8L6 11L11 3.5"
//                                     strokeWidth={2}
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     className="opacity-0 group-has-[:checked]:opacity-100"
//                                   />
//                                   <path
//                                     d="M3 7H11"
//                                     strokeWidth={2}
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     className="opacity-0 group-has-[:indeterminate]:opacity-100"
//                                   />
//                                 </svg>
//                               </div>
//                             </div>
//                             <label
//                               htmlFor={`filter-mobile-${section.id}-${optionIdx}`}
//                               className="min-w-0 flex-1 text-gray-500"
//                             >
//                               {option.label}
//                             </label>
//                           </div>
//                         ))}
//                       </div>
//                     </DisclosurePanel>
//                   </Disclosure>
//                 ))}
//               </form>
//               <Dialog
//   open={mobileFiltersOpen}
//   onClose={setMobileFiltersOpen}
//   className="lg:hidden fixed inset-0 z-[9999] flex justify-end"
// >
//   {/* پس‌زمینه محو */}
//   <DialogBackdrop
//     transition
//     className="fixed inset-0 bg-black/30 transition-opacity duration-300 ease-in-out data-[closed]:opacity-0"
//   />

//   {/* خود پنل فیلتر - از سمت راست باز می‌شه */}
//   <DialogPanel
//     transition
//     className="relative w-80 max-w-xs h-full bg-white shadow-xl transform transition-transform duration-300 ease-in-out 
//     data-[closed]:translate-x-full data-[enter]:translate-x-0"
//   >
//     <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
//       <h2 className="text-lg font-semibold text-gray-900">فیلترها</h2>
//       <button
//         onClick={() => setMobileFiltersOpen(false)}
//         className="p-2 text-gray-400 hover:text-gray-600"
//       >
//         <XMarkIcon className="h-6 w-6" />
//       </button>
//     </div>

//     {/* محتوای فیلتر */}
//     <div className="p-4 overflow-y-auto">
//       {filters.map((section) => (
//         <Disclosure key={section.id} as="div" className="border-b border-gray-200 py-4">
//           <DisclosureButton className="flex justify-between w-full text-gray-800 font-medium">
//             {section.name}
//             <ChevronDownIcon className="h-5 w-5 text-gray-500" />
//           </DisclosureButton>
//           <DisclosurePanel className="pt-2 space-y-2">
//             {section.options.map((option) => (
//               <label key={option.value} className="flex items-center gap-2 text-sm text-gray-600">
//                 <input type="checkbox" defaultChecked={option.checked} />
//                 {option.label}
//               </label>
//             ))}
//           </DisclosurePanel>
//         </Disclosure>
//       ))}
//     </div>
//   </DialogPanel>
//               </Dialog>

//           <div className="flex items-baseline justify-between border-b border-gray-200 pb-6 pt-24 w-full">
//             <h1 className="text-4xl font-bold tracking-tight text-gray-900">New Arrivals</h1>

//             <div className="flex items-center">
//               <Menu as="div" className="relative inline-block text-left">
//                 <MenuButton className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
//                   Sort
//                   <ChevronDownIcon
//                     aria-hidden="true"
//                     className="-mr-1 ml-1 size-5 shrink-0 text-gray-400 group-hover:text-gray-500"
//                   />
//                 </MenuButton>

//                 <MenuItems
//                   transition
//                   className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
//                 >
//                   <div className="py-1">
//                     {sortOptions.map((option) => (
//                       <MenuItem key={option.name}>
//                         <a
//                           href={option.href}
//                           className={classNames(
//                             option.current ? 'font-medium text-gray-900' : 'text-gray-500',
//                             'block px-4 py-2 text-sm data-[focus]:bg-gray-100 data-[focus]:outline-none',
//                           )}
//                         >
//                           {option.name}
//                         </a>
//                       </MenuItem>
//                     ))}
//                   </div>
//                 </MenuItems>
//               </Menu>

//               <button type="button" className="-m-2 ml-5 p-2 text-gray-400 hover:text-gray-500 sm:ml-7">
//                 <span className="sr-only">View grid</span>
//                 <Squares2X2Icon aria-hidden="true" className="size-5" />
//               </button>
//               <button
//                 type="button"
//                 onClick={() => setMobileFiltersOpen(true)}
//                 className="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden"
//               >
//                 <span className="sr-only">Filters</span>
//                 <FunnelIcon aria-hidden="true" className="size-5" />
//               </button>
//             </div>
//           </div>

//           <section aria-labelledby="products-heading" className="pb-24 pt-6">
//             <h2 id="products-heading" className="sr-only">
//               Products
//             </h2>

//             <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
//               {/* Filters */}
//               <form className="hidden lg:block">
//                 <h3 className="sr-only">Categories</h3>
//                 <ul role="list" className="space-y-4 border-b border-gray-200 pb-6 text-sm font-medium text-gray-900">
//                   {subCategories.map((category) => (
//                     <li key={category.name}>
//                       <a href={category.href}>{category.name}</a>
//                     </li>
//                   ))}
//                 </ul>

//                 {filters.map((section) => (
//                   <Disclosure key={section.id} as="div" className="border-b border-gray-200 py-6">
//                     <h3 className="-my-3 flow-root">
//                       <DisclosureButton className="group flex w-full items-center justify-between bg-white py-3 text-sm text-gray-400 hover:text-gray-500">
//                         <span className="font-medium text-gray-900">{section.name}</span>
//                         <span className="ml-6 flex items-center">
//                           <PlusIcon aria-hidden="true" className="size-5 group-data-[open]:hidden" />
//                           <MinusIcon aria-hidden="true" className="size-5 group-[:not([data-open])]:hidden" />
//                         </span>
//                       </DisclosureButton>
//                     </h3>
//                     <DisclosurePanel className="pt-6">
//                       <div className="space-y-4">
//                         {section.options.map((option, optionIdx) => (
//                           <div key={option.value} className="flex gap-3">
//                             <div className="flex h-5 shrink-0 items-center">
//                               <div className="group grid size-4 grid-cols-1">
//                                 <input
//                                   defaultValue={option.value}
//                                   defaultChecked={option.checked}
//                                   id={`filter-${section.id}-${optionIdx}`}
//                                   name={`${section.id}[]`}
//                                   type="checkbox"
//                                   className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
//                                 />
//                                 <svg
//                                   fill="none"
//                                   viewBox="0 0 14 14"
//                                   className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
//                                 >
//                                   <path
//                                     d="M3 8L6 11L11 3.5"
//                                     strokeWidth={2}
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     className="opacity-0 group-has-[:checked]:opacity-100"
//                                   />
//                                   <path
//                                     d="M3 7H11"
//                                     strokeWidth={2}
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     className="opacity-0 group-has-[:indeterminate]:opacity-100"
//                                   />
//                                 </svg>
//                               </div>
//                             </div>
//                             <label htmlFor={`filter-${section.id}-${optionIdx}`} className="text-sm text-gray-600">
//                               {option.label}
//                             </label>
//                           </div>
//                         ))}
//                       </div>
//                     </DisclosurePanel>
//                   </Disclosure>
//                 ))}
//               </form>

//               {/* Product grid */}
//               <div className="lg:col-span-3">{/* Your content */}</div>
//             </div>
//           </section>
//         </main>

//     </div>
//         </div>
//         <Footer />
//       </div>
//     </div>
//   </>

//   )
// }




// import React, { useState } from "react";
// import { Dialog, Disclosure, Menu } from "@headlessui/react";
// import { XMarkIcon, PlusIcon, MinusIcon, FunnelIcon, Squares2X2Icon, ChevronDownIcon } from "@heroicons/react/24/outline";
// import Header from 'units/dashboard/components/Header'
// import UserSidebar from 'units/user/components/UserSidebar'
// import Footer from 'units/dashboard/components/Footer'

// export default function AddNewTool() {
//   const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

//   // مثال داده‌ها
//   const subCategories = [{ name: "Category 1", href: "#" }, { name: "Category 2", href: "#" }];
//   const filters = [
//     {
//       id: "color",
//       name: "Color",
//       options: [
//         { value: "red", label: "Red", checked: false },
//         { value: "blue", label: "Blue", checked: true },
//       ],
//     },
//     {
//       id: "size",
//       name: "Size",
//       options: [
//         { value: "small", label: "Small", checked: false },
//         { value: "large", label: "Large", checked: false },
//       ],
//     },
//   ];
//   const sortOptions = [
//     { name: "Most Popular", href: "#", current: true },
//     { name: "Newest", href: "#", current: false },
//   ];

//   return (
//     <>
//       {/* Header */}
//       <nav className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-20 dark:border-zinc-700">
//         <Header />
//       </nav>

//       {/* Sidebar */}
//       <div className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
//         <UserSidebar />
//       </div>

//       <div className="flex flex-col min-h-screen">
//         <div className="main-content flex-grow">
//           <div className="page-content mt-1">
//             <div className="container-fluid px-[0.625rem]">
//               <div className="grid grid-cols-1 mb-2">
//                 <div className="flex items-center justify-between">
//                   <nav className="flex" aria-label="Breadcrumb"></nav>
//                 </div>
//               </div>
//             </div>

//             {/* Dialog - Mobile Filters */}
//             <Dialog
//               open={mobileFiltersOpen}
//               onClose={() => setMobileFiltersOpen(false)}
//               className="fixed inset-0 z-50 flex lg:hidden"
//             >
//               <Dialog.Overlay className="fixed inset-0 bg-black/25" />

//               <div className="relative ml-auto flex h-full max-w-xs flex-col overflow-y-auto bg-white pb-6 pt-4 shadow-xl">
//                 <div className="flex items-center justify-between px-4">
//                   <h2 className="text-lg font-medium text-gray-900">Filters</h2>
//                   <button
//                     type="button"
//                     onClick={() => setMobileFiltersOpen(false)}
//                     className="relative -mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white text-gray-400 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                   >
//                     <span className="sr-only">Close menu</span>
//                     <XMarkIcon className="h-6 w-6" aria-hidden="true" />
//                   </button>
//                 </div>

//                 <form className="mt-4 border-t border-gray-200">
//                   <h3 className="sr-only">Categories</h3>
//                   <ul role="list" className="px-2 py-3 font-medium text-gray-900">
//                     {subCategories.map((category) => (
//                       <li key={category.name}>
//                         <a href={category.href} className="block px-2 py-3">
//                           {category.name}
//                         </a>
//                       </li>
//                     ))}
//                   </ul>

//                   {filters.map((section) => (
//                     <Disclosure key={section.id} as="div" className="border-t border-gray-200 px-4 py-6">
//                       <Disclosure.Button className="flex w-full items-center justify-between bg-white px-2 py-3 text-gray-400 hover:text-gray-500">
//                         <span className="font-medium text-gray-900">{section.name}</span>
//                         <span className="ml-6 flex items-center">
//                           <PlusIcon className="h-5 w-5 group-open:hidden" aria-hidden="true" />
//                           <MinusIcon className="h-5 w-5 hidden group-open:block" aria-hidden="true" />
//                         </span>
//                       </Disclosure.Button>
//                       <Disclosure.Panel className="pt-6">
//                         <div className="space-y-6">
//                           {section.options.map((option, optionIdx) => (
//                             <div key={option.value} className="flex gap-3">
//                               <div className="flex h-5 items-center">
//                                 <input
//                                   id={`filter-mobile-${section.id}-${optionIdx}`}
//                                   name={`${section.id}[]`}
//                                   type="checkbox"
//                                   defaultValue={option.value}
//                                   defaultChecked={option.checked}
//                                   className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
//                                 />
//                               </div>
//                               <label htmlFor={`filter-mobile-${section.id}-${optionIdx}`} className="text-gray-500">
//                                 {option.label}
//                               </label>
//                             </div>
//                           ))}
//                         </div>
//                       </Disclosure.Panel>
//                     </Disclosure>
//                   ))}
//                 </form>
//               </div>
//             </Dialog>

//             {/* Main Content */}
//             <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//               <div className="flex items-baseline justify-between border-b border-gray-200 pb-6 pt-24">
//                 <h1 className="text-4xl font-bold tracking-tight text-gray-900">New Arrivals</h1>

//                 <div className="flex items-center">
//                   <Menu as="div" className="relative inline-block text-left">
//                     <Menu.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
//                       Sort
//                       <ChevronDownIcon className="-mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
//                     </Menu.Button>
//                     <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black/5 focus:outline-none">
//                       <div className="py-1">
//                         {sortOptions.map((option) => (
//                           <Menu.Item key={option.name}>
//                             {({ active }) => (
//                               <a
//                                 href={option.href}
//                                 className={`block px-4 py-2 text-sm ${option.current ? "font-medium text-gray-900" : "text-gray-500"}`}
//                               >
//                                 {option.name}
//                               </a>
//                             )}
//                           </Menu.Item>
//                         ))}
//                       </div>
//                     </Menu.Items>
//                   </Menu>

//                   <button type="button" className="-m-2 ml-5 p-2 text-gray-400 hover:text-gray-500 sm:ml-7">
//                     <span className="sr-only">View grid</span>
//                     <Squares2X2Icon className="h-5 w-5" aria-hidden="true" />
//                   </button>
//                   <button
//                     type="button"
//                     onClick={() => setMobileFiltersOpen(true)}
//                     className="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden"
//                   >
//                     <span className="sr-only">Filters</span>
//                     <FunnelIcon className="h-5 w-5" aria-hidden="true" />
//                   </button>
//                 </div>
//               </div>

//               <section aria-labelledby="products-heading" className="pb-24 pt-6">
//                 <h2 id="products-heading" className="sr-only">
//                   Products
//                 </h2>

//                 <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
//                   {/* Desktop Filters */}
//                   <form className="hidden lg:block">
//                     <h3 className="sr-only">Categories</h3>
//                     <ul className="space-y-4 border-b border-gray-200 pb-6 text-sm font-medium text-gray-900">
//                       {subCategories.map((category) => (
//                         <li key={category.name}>
//                           <a href={category.href}>{category.name}</a>
//                         </li>
//                       ))}
//                     </ul>

//                     {filters.map((section) => (
//                       <Disclosure key={section.id} as="div" className="border-b border-gray-200 py-6">
//                         <Disclosure.Button className="flex w-full items-center justify-between bg-white py-3 text-sm text-gray-400 hover:text-gray-500">
//                           <span className="font-medium text-gray-900">{section.name}</span>
//                           <span className="ml-6 flex items-center">
//                             <PlusIcon className="h-5 w-5 group-open:hidden" aria-hidden="true" />
//                             <MinusIcon className="h-5 w-5 hidden group-open:block" aria-hidden="true" />
//                           </span>
//                         </Disclosure.Button>
//                         <Disclosure.Panel className="pt-6">
//                           <div className="space-y-4">
//                             {section.options.map((option, optionIdx) => (
//                               <div key={option.value} className="flex gap-3">
//                                 <div className="flex h-5 items-center">
//                                   <input
//                                     id={`filter-${section.id}-${optionIdx}`}
//                                     name={`${section.id}[]`}
//                                     type="checkbox"
//                                     defaultValue={option.value}
//                                     defaultChecked={option.checked}
//                                     className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
//                                   />
//                                 </div>
//                                 <label htmlFor={`filter-${section.id}-${optionIdx}`} className="text-sm text-gray-600">
//                                   {option.label}
//                                 </label>
//                               </div>
//                             ))}
//                           </div>
//                         </Disclosure.Panel>
//                       </Disclosure>
//                     ))}
//                   </form>

//                   {/* Product Grid */}
//                   <div className="lg:col-span-3">{/* Your content */}</div>
//                 </div>
//               </section>
//             </main>
//           </div>
//         </div>
//         <Footer />
//       </div>

//   </>
//   );
// }

import { useState } from 'react'
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from '@headlessui/react'

import { ChevronDownIcon, FunnelIcon, MinusIcon, PlusIcon, Squares2X2Icon } from '@heroicons/react/20/solid'
import Header from 'units/dashboard/components/Header'
import UserSidebar from 'units/user/components/UserSidebar'
import Footer from 'units/dashboard/components/Footer'
import ToolsSidebar from './components/ToolsSidebar'
import { DialogTitle } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import HTTP from './components/HTTP'
import FormFilling from './components/FormFilling'
import { FaBars } from "react-icons/fa";
import { FiArrowLeft } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
const components = {
  HTTP,
  FormFilling,

};

export default function AddNewTool() {
  const [activeComponent, setActiveComponent] = useState("FormFilling");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const ComponentToShow = components[activeComponent];
  const navigate = useNavigate();
  return (
    <>

      <nav className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
        <Header />
      </nav>

      <div className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
        <UserSidebar />
      </div>

      <div className="flex flex-col min-h-screen">
        <div className="main-content flex-grow ">
          <div className="page-content mt-1">
            <div className="container-fluid px-[0.625rem]">
              <div className="grid grid-cols-1 mb-12 ml-10 xl:ml-64">
                <div className="flex items-center justify-between">
                  <h4 className="mb-sm-0 text-2xl font-semibold grow text-gray-800 ">
                    ابزارهای من
                  </h4>
                  <button 
                    onClick={() => navigate("/user/tools")}
                  className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200
                   text-gray-800 font-medium rounded-md shadow-sm transition-all duration-200">
                    
                    برگشت
                    <FiArrowLeft size={18} />
                  </button>
                  <button
                    className="xl:hidden absolute top-22 left-4 z-50 p-2 bg-gray-900 text-white rounded-md shadow-lg"
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                  >
                    <FaBars size={20} />
                  </button>
                </div>
              </div>
              {/* <h1 className="text-lg mr-2"> مدیر محترم به داشبورد کاربری خوش آمدید . </h1> */}
            </div>
            <div className=" w-full">
              <div className="flex h-full ">
                {/* دکمه موبایل */}
                {/* <button
                  className="xl:hidden fixed top-22 left-4 z-50 p-2 bg-gray-900 text-white rounded-md shadow-lg"
                  onClick={() => setSidebarOpen(!sidebarOpen)}
                >
                  <FaBars size={20} />
                </button> */}

                {/* سایدبار */}

                <ToolsSidebar
                  componentsKeys={Object.keys(components)}
                  activeComponent={activeComponent}
                  setActiveComponent={setActiveComponent}
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                />



                {/* محتوای اصلی */}
                <div className="  p-6 overflow-auto  h-full 
                 w-full  "
                >
                  <ComponentToShow />
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>

  )
}

// import { useState } from 'react'
// import {
//   Dialog,
//   DialogBackdrop,
//   DialogPanel,
//   Disclosure,
//   DisclosureButton,
//   DisclosurePanel,
//   Menu,
//   MenuButton,
//   MenuItem,
//   MenuItems,
// } from '@headlessui/react'

// import { ChevronDownIcon, FunnelIcon, MinusIcon, PlusIcon, Squares2X2Icon } from '@heroicons/react/20/solid'
// import Header from 'units/dashboard/components/Header'
// import UserSidebar from 'units/user/components/UserSidebar'
// import Footer from 'units/dashboard/components/Footer'
// import ToolsSidebar from './components/ToolsSidebar'
// import { DialogTitle } from '@headlessui/react'
// import { XMarkIcon } from '@heroicons/react/24/outline'
// import HTTP from './components/HTTP'
// import FormFilling from './components/FormFilling'
// import { FaBars } from "react-icons/fa";
// const components = {
//   HTTP,
//   FormFilling,

// };

// export default function AddNewTool() {
//   const [activeComponent, setActiveComponent] = useState("FormFilling");
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const ComponentToShow = components[activeComponent];

//   return (
//     <>

//       <nav className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
//         <Header />
//       </nav>

//       <div className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
//         <UserSidebar />
//       </div>

//       <div className="flex flex-col min-h-screen">
//         <div className="main-content flex-grow ">
//           <div className="page-content mt-1">
//             <div className="container-fluid px-[0.625rem]">
//               <div className="grid grid-cols-1 mb-2">
//                 <div className="flex items-center justify-between">
//                   {/* <h4 className="mb-sm-0 text-2xl font-semibold grow text-gray-800 ">
//                   داشبورد
//                 </h4> */}
//                   <nav className="flex" aria-label="Breadcrumb"></nav>
//                 </div>
//               </div>
//               {/* <h1 className="text-lg mr-2"> مدیر محترم به داشبورد کاربری خوش آمدید . </h1> */}
//             </div>
//             <div className=" w-full">
//               <div className="flex h-full ">
//                 {/* دکمه موبایل */}
//                 <button
//                   className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-gray-900 text-white rounded-md shadow-lg"
//                   onClick={() => setSidebarOpen(!sidebarOpen)}
//                 >
//                   <FaBars size={20} />
//                 </button>

//                 <div className="flex  overflow-hidden">
//                   <ToolsSidebar
//                     componentsKeys={Object.keys(components)}
//                     activeComponent={activeComponent}
//                     setActiveComponent={setActiveComponent}
//                     sidebarOpen={sidebarOpen}
//                     setSidebarOpen={setSidebarOpen}
//                   />

//                   <main className="w-full  p-6 h-full mx-auto">
//                     <ComponentToShow />
//                   </main>
//                 </div>

//               </div>
//             </div>
//           </div>
//           <Footer />
//         </div>
//       </div>
//     </>

//   )
// }
